import { React, useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import db from "../firebase";
import Cookies from "js-cookie";
import { Navigate, useNavigate } from "react-router-dom";
import { UserContext } from "./User";
import getBrowserFingerprint from "get-browser-fingerprint";
import DATA from "./Data";
import { ReactComponent as LagoonLogo } from "../assets/logo.svg";
// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { Firestore } from "firebase/firestore";

export default function SignIn() {
	const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();
	const { user, setUser } = useContext(UserContext);
	const [users, setUsers] = useState([]);
	const [fingerprint, setFingerprint] = useState();
	const [company, setCompany] = useState("ft");
	const navigate = useNavigate();

	useEffect(() => {
		if (users.length === 0) {
			onSnapshot(collection(db, "users"), (snapshot) =>
				setUsers(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
			);
		} else if (users.length !== 0 && fingerprint) {
			users.forEach((user) => {
				if (user.fingerprint === fingerprint) {
					Cookies.set("id", user.id);
					Cookies.set("lastLogin", Date.now());
					setUser(user);
					return user;
				}
			});
		}
	}, [users, fingerprint]);

	// useEffect(() => {
	// 	if (!fingerprint) {
	// 		const fpPromise = FingerprintJS.load({
	// 			apiKey: "XjuHS179kM6xN4lfdR95",
	// 		});
	// 		fpPromise
	// 			.then((fp) => fp.get())
	// 			.then((result) => {
	// 				setFingeprint(result.visitorId);
	// 			});
	// 	} else {
	// 		console.log(fingerprint);
	// 	}
	// }, [fingerprint]);

	useEffect(() => {
		if (!fingerprint) {
			console.log('Generating fingerprint...');
	
			const generateFingerprint = async (ipAddress) => {
				try {
					var finalFingerprint = ipAddress ? ipAddress.replace(/\./g, '') : '';
					try {
						const fingerprint = await getCurrentBrowserFingerPrint();
						finalFingerprint += fingerprint;
					} catch (error) {
						console.log(error);
					}
					return finalFingerprint;
				} catch (error) {
					console.log('Error generating fingerprint:', error);
					return ipAddress;
				}
			};
	
			const updateFingerprintState = (finalFingerprint) => {
				if (finalFingerprint !== null) {
					console.log('Setting fingerprint in state: ' + finalFingerprint);
					setFingerprint(finalFingerprint);
				} else {
					console.log('Setting empty fingerprint in state.');
					setFingerprint('');
				}
			};
	
			const fetchIpAddress = () => {
				console.log('Fetching IP address...');
				return fetch('https://api.ipify.org?format=json')
					.then(response => response.json())
					.then(data => {
						const ipAddress = data.ip;
						console.log('Fetched IP address:', ipAddress);
						return ipAddress;
					})
					.catch(error => {
						console.log('Error fetching IP address:', error);
						return null; // Return null in case of any error
					});
			};
	
			fetchIpAddress()
				.then(ipAddress => generateFingerprint(ipAddress))
				.then(finalFingerprint => updateFingerprintState(finalFingerprint))
				.catch(error => {
					console.log('Error in fingerprint generation:', error);
					updateFingerprintState(null); // Handle error case
				});
		} else {
			console.log('Fingerprint already set:', fingerprint);
		}
	}, [fingerprint]);

	
	// useEffect(() => {
    //     if (!fingerprint) {
    //         console.log('Generating fingerprint...');

	// 		const generateFingerprint = async (ipAddress) => {
	// 			try {
	// 				var finalFingerprint = ipAddress ? ipAddress.replace(/\./g, '') : '';
	// 				getCurrentBrowserFingerPrint().then((fingerprint) => {
	// 					finalFingerprint = finalFingerprint + fingerprint;
	// 					return finalFingerprint;
	// 				}).catch(error => {
	// 					console.log(error);
	// 					return finalFingerprint;
	// 				});
	// 			} catch (error) {
	// 				console.log('Error generating fingerprint:', error);
	// 				return ipAddress;
	// 			}
	// 		}

    //         // const generateFingerprint = async (ipAddress) => {
    //         //     try {
    //         //         // const fp = await FingerprintJS.load();
    //         //         // const { visitorId } = await fp.get();
	// 		// 		// var visitorId
	// 		// 		// const { visitorId } = getCurrentBrowserFingerPrint();
	// 		// 		// Prepend IP address (without periods) to the fingerprint if available
	// 		// 		const finalFingerprint = ipAddress ? ipAddress.replace(/\./g, '') + visitorId : visitorId;
	// 		// 		console.log('Generated fingerprint:', finalFingerprint);
	// 		// 		return finalFingerprint;
    //         //     } catch (error) {
    //         //         console.log('Error generating fingerprint:', error);
    //         //         return null;
    //         //     }
    //         // };

    //         const updateFingerprintState = (finalFingerprint) => {
    //             if (finalFingerprint !== null) {
    //                 console.log('Setting fingerprint in state: ' + finalFingerprint);
    //                 setFingerprint(finalFingerprint);
    //             } else {
    //                 console.log('Setting empty fingerprint in state.');
    //                 setFingerprint('');
    //             }
    //         };

    //         const fetchIpAddress = () => {
    //             console.log('Fetching IP address...');
    //             return fetch('https://api.ipify.org?format=json')
    //                 .then(response => response.json())
    //                 .then(data => {
    //                     const ipAddress = data.ip;
    //                     console.log('Fetched IP address:', ipAddress);
    //                     return ipAddress;
    //                 })
    //                 .catch(error => {
    //                     console.log('Error fetching IP address:', error);
    //                     return null; // Return null in case of any error
    //                 });
    //         };

    //         fetchIpAddress()
    //             .then(ipAddress => generateFingerprint(ipAddress))
    //             .then(finalFingerprint => updateFingerprintState(finalFingerprint))
    //             .catch(error => {
    //                 console.log('Error in fingerprint generation:', error);
    //                 updateFingerprintState(null); // Handle error case
    //             });
    //     } else {
    //         console.log('Fingerprint already set:', fingerprint);
    //     }
    // }, [fingerprint]);

	useEffect(() => {
		if (users.length === 0) {
			onSnapshot(collection(db, "users"), (snapshot) =>
				setUsers(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
			);
		} else {
			users.forEach((user) => {
				if (user.fingerprint === fingerprint) {
					Cookies.set("id", user.id);
					console.log(Date.now());
					setUser(user);
					// return user;
				}
			});
		}
	}, [users]);

	// useEffect(() => {
	// 	console.log(user);
	// 	console.log(Date.now());
	// }, [user]);

	const signUpUser = async (data) => {
		let randomGiftNum =
			users.length +
			Math.floor(Math.random() * 25) +
			Math.floor(Math.random() * 99) +
			Math.floor(Math.random() * 30);
		randomGiftNum =
			randomGiftNum +
			Math.floor(Math.random() * 5) +
			Math.pow(Math.floor(Math.random() * 5), 2) -
			Math.floor(Math.random() * 10);
		if (randomGiftNum >= 300) {
			randomGiftNum = users.length;
			if (randomGiftNum >= 300) {
				randomGiftNum -= Math.floor(Math.random() * 99);
			}
		}
		const newUser = addDoc(collection(db, "users"), {
			firstName: data.firstName,
			lastName: "",
			email: data.email,
			profileComplete: false,
			score: 0,
			fingerprint: fingerprint,
			progress: DATA.PROGRESS,
			rewards: DATA.REWARDS,
			logoUrl:
				"https://firebasestorage.googleapis.com/v0/b/lagoon-118b4.appspot.com/o/logos%2F" +
				randomGiftNum +
				".png?alt=media",
			avatarUrl:
				"https://firebasestorage.googleapis.com/v0/b/lagoon-118b4.appspot.com/o/avatars%2F" +
				randomGiftNum +
				".png?alt=media",
			avatarRevealed: "",
			logoRevealed: false,
			drinkRedeemed: false,
			lastLogin: Date.now(),
			activationCode:
				Date.now()
					.toString()
					.substring(Date.now().toString().length - 4) +
				Math.floor(Math.random() * 100),
			randomGiftNum: randomGiftNum,
			drinkCode:
				data.firstName +
				Date.now()
					.toString()
					.substring(Date.now().toString().length - 4),
		}).then((docRef) => {
			Cookies.set("id", docRef.id);
			Cookies.set("lastLogin", Date.now());
			setUser(newUser);
			return user;
		});
	};

	return Cookies.get().id ? (
		<Navigate to="/?unlock=9090909d9ru" />
	) : (
		<>
			<LagoonLogo className="lagoon-logo" />
			<h2 id="signin-header">Join our world</h2>
			<form id="signin-form">
				{/* <label htmlFor="firstName">First Name</label> */}
				<input
					{...register("firstName", { required: "Your name is required" })}
					placeholder="Your Name"
				/>
				<p>{errors.firstName?.message}</p>
				{/* <label htmlFor="lastName">Last Name</label> */}
				{/* <input
					{...register("lastName", { required: "Your last name is required" })}
					placeholder="Last Name"
				/>
				<p>{errors.lastName?.message}</p> */}
				{/* <label htmlFor="company">Company ID</label> */}
				<input
					{...register("email", {
						required: "Please enter your email address",
						pattern: {
							value:
								/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
							message: "Invalid email address",
						},
					})}
					placeholder="Email"
				/>
				<p>{errors.email?.message}</p>
				<button
					onClick={handleSubmit((data) => {
						signUpUser(data);
						// reset();
					})}
					type="submit"
				>
					Join
				</button>
				<button class="no-button" onClick={() => navigate("/signup1")}>
					I already have an account
				</button>
			</form>
		</>
	);
}
